import styled from "@emotion/styled";
import { Text } from "../../general/Text";
import { getAutoCompleteString } from "../../../utils/TokenSelector/utils";
import { Hash } from "viem";
import { TokenList } from "../../../store/global/getAllTokenLists";

interface AutoCompleteSuggestionProps {
  searchString: string;
  tokenList: TokenList | undefined;
  tokensSortedByBalance: Array<Hash>;
}
export const AutoCompleteSuggestion = ({
  searchString,
  tokenList,
  tokensSortedByBalance,
}: AutoCompleteSuggestionProps) => {
  return (
    <AutocompleteSuggestionContainer>
      <Text textStyle={"Title"} size={"Medium"}>
        {getAutoCompleteString(searchString, tokenList, tokensSortedByBalance)}
      </Text>
    </AutocompleteSuggestionContainer>
  );
};

const AutocompleteSuggestionContainer = styled.div`
  position: absolute;
  z-index: 1;
  color: ${({ theme }) => theme.font.tertiary.default};
  line-height: 1.4;
  top: 15px;
`;
